
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var gridWrap = document.getElementById('product-grid');
    if (!gridWrap) return;

    // Dawn nests the <ul class="grid"> inside #product-grid; append there.
    var list = gridWrap.querySelector('ul.grid') || gridWrap.querySelector('.grid') || gridWrap;

    function resolveHref(h) {
      if (!h) return null;
      if (/^https?:\/\//i.test(h)) return h;
      if (h.charAt(0) === '/') return window.location.origin + h;
      return null;
    }

    // Find the "next page" link. NOTE: this theme's pagination has the
    // pagination__item--prev / --next CSS classes SWAPPED, so we must NOT
    // trust those classes. The aria-label ("Next page") is correct; we also
    // keep a page-number fallback (current + 1) for robustness/localization.
    function currentPage(root) {
      var cur = (root || document).querySelector('.pagination [aria-current], .pagination__item--current');
      var n = cur ? parseInt((cur.textContent || '').trim(), 10) : 1;
      return isNaN(n) ? 1 : n;
    }
    function nextUrlFrom(root) {
      var pag = (root || document).querySelector('nav.pagination, .pagination');
      if (!pag) return null;

      // Primary: aria-label contains "next" but not "prev".
      var a = pag.querySelector('a[aria-label*="next" i]:not([aria-label*="prev" i])');
      if (a) return resolveHref(a.getAttribute('href'));

      // Fallback: the anchor that points to (current page + 1).
      var want = currentPage(root) + 1, best = null;
      pag.querySelectorAll('a[href]').forEach(function (x) {
        var m = (x.getAttribute('href') || '').match(/[?&]page=(\d+)/);
        if (m && parseInt(m[1], 10) === want) best = x;
      });
      return best ? resolveHref(best.getAttribute('href')) : null;
    }

    var nextUrl = nextUrlFrom(document);
    if (!nextUrl) return; // single page of results — nothing to do

    var pagination = document.querySelector('nav.pagination, .pagination');
    var loading = false;
    var done = false;

    // Dedupe by link pathname (works for products, articles and pages).
    var seen = {};
    function itemKey(li) {
      var a = li.querySelector('a[href]');
      if (!a) return null;
      var href = a.getAttribute('href') || '';
      return href.split('?')[0].split('#')[0];
    }
    list.querySelectorAll('.grid__item').forEach(function (li) {
      var k = itemKey(li);
      if (k) seen[k] = true;
    });

    // Hide the numbered pagination once infinite scroll is active.
    if (pagination) pagination.style.display = 'none';

    var loader = document.createElement('div');
    loader.className = 'th-search-loading';
    loader.textContent = 'Loading…';
    loader.style.cssText = 'text-align:center;padding:2.4rem;font-size:1.4rem;opacity:.6;display:none;';
    gridWrap.appendChild(loader);

    function loadNext() {
      if (loading || done || !nextUrl) return;
      loading = true;
      loader.style.display = 'block';

      fetch(nextUrl)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var srcWrap = doc.getElementById('product-grid');
          var items = srcWrap ? srcWrap.querySelectorAll('.grid__item') : [];

          if (!items.length) { done = true; loader.style.display = 'none'; loading = false; return; }

          var appended = 0;
          items.forEach(function (li) {
            var k = itemKey(li);
            if (k && seen[k]) return;          // dedupe
            if (k) seen[k] = true;
            var clone = li.cloneNode(true);
            // Strip Dawn's scroll-in animation classes so cloned items are
            // visible immediately (the animation observer won't see clones).
            clone.classList.remove('scroll-trigger', 'animate--slide-in');
            clone.querySelectorAll('.scroll-trigger').forEach(function (el) {
              el.classList.remove('scroll-trigger', 'animate--slide-in');
            });
            list.appendChild(clone);
            appended++;
          });

          nextUrl = nextUrlFrom(doc);
          if (!nextUrl) done = true;
          if (appended === 0) done = true;     // safety: stop if nothing new

          loader.style.display = 'none';
          loading = false;

          // If the new batch didn't fill the viewport, keep going.
          setTimeout(onScroll, 200);
        })
        .catch(function (err) {
          console.error('[TENHEM] Search infinite scroll error:', err);
          loader.style.display = 'none';
          loading = false;
        });
    }

    function onScroll() {
      if (done || loading || !nextUrl) return;
      if (window.scrollY + window.innerHeight >= document.body.scrollHeight - 800) loadNext();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(onScroll, 300); // in case the first page is already short
  });
})();
